import { appendScript } from '../../utils/appendScript';
import { removeScript } from '../../utils/removeScript';
import moment from 'moment';
import {
	playAudioInstruction,
	playVideoInstruction,
	readInstruction,
} from '../../utils/const';
import Config from '../../config/Config';
import { htmlDecode, htmlEncode } from '../../utils/commonFunctions';

export const getQuestionData = (data) => {
	let isFeedback = false;
	let {
		attempt: { active_section_id, element_type, element_id },
		next_question,
		element_name,
		answers,
		answer_count,
		question_count,
		attempt_progress,
		is_close,
		element_description,
		show_feedback: { show_feedback },
		time_remaining,
	} = data;

	localStorage.setItem(
		'video_id',
		!!answers[0] ? answers[0].source_youtube_video : '',
	);

	let hasVideo = false;
	let response = {};
	let submitButton = '';
	let feedback = {};
	let disableSubmit = false;
	if (
		!!show_feedback &&
		show_feedback === 'Y' &&
		!!answers &&
		answers.length > 0 &&
		localStorage.getItem('withoutFeedback') === null
	) {
		isFeedback = true;
		feedback = answers;
		response = answers[0].question;
		submitButton = 'Next';
		disableSubmit = false;
		hasVideo = !!answers[0].source_youtube_video;
	} else {
		response = next_question;
		submitButton = 'Submit';
		disableSubmit = true;
		hasVideo = !!next_question[0] && !!next_question[0].source_youtube_video;
	}

	if (localStorage.getItem('withoutFeedback') !== null) {
		localStorage.removeItem('withoutFeedback');
	}

	if (!!element_type && (element_type === 'S' || element_type === 'F')) {
		const script31 = document.createElement('script');
		var code = 'var timeremaininginseconds = ' + time_remaining + ';';
		script31.appendChild(document.createTextNode(code));
		document.body.appendChild(script31);

		//if (!hasVideo) {
		appendScript('testpage');
		//}
	}
	appendScript('app');

	return {
		audioblob: [],
		videoblob: [],
		elementId: element_id,
		answerCount: answer_count,
		questionCount: question_count,
		aSectionId: active_section_id,
		elementType: element_type,
		attemptProgress: attempt_progress,
		timeRemaining: time_remaining,
		isFeedback,
		questions: next_question,
		element_name,
		feedback,
		response,
		submitButton,
		leftFeedbackProps: isFeedback ? { ...getLeftFeedbackProps(answers[0]) } : {},
		rightFeedbackProps: isFeedback
			? { ...getRightFeedbackProps(answers[0]) }
			: {},
		leftSectionProps: !!next_question[0]
			? {
				...getLeftSectionProps(next_question[0], element_name, element_id),
				videoReplayCount: next_question.length > 1 ? 2 : '',
			}
			: {},
		rightSectionProps: !!next_question[0]
			? { ...getRightSectionProps(next_question[0], isFeedback) }
			: {},
		isFireFox: typeof InstallTrigger !== 'undefined',
		questionNo: answer_count + 1,
		isMultiQuestion: next_question.length > 1,
		disableSubmit,
		isClose: is_close,
		elementDescription: element_description,
		questionId: isFeedback
			? answers[0].question.question_id
			: !!next_question[0]
				? next_question[0].question_id
				: 0,
	};
};

const getLeftSectionProps = (
	{
		source_text_or_html,
		source_youtube_video,
		youtube_start,
		youtube_end,
		type,
		source_image_url,
		domain,
		segment,
		word_bank,
		karaoke_details,
		question_id,
		question,
		prompt,
		level,
	},
	element_name,
	element_id,
) => {
	let isNotCloze =
		type !== 'CLOZE' &&
		type !== 'Cloze_with_passage' &&
		type !== 'Cloze_with_conversation';

	return {
		videoId: source_youtube_video,
		youtubeStart: youtube_start,
		youtubeEnd: youtube_end,
		queDesc:
			!!source_text_or_html && !!source_text_or_html.trim() && isNotCloze
				? htmlDecode(source_text_or_html).trim()
				: '',
		imagesrc: source_image_url,
		wordbank: word_bank,
		clozeQuestion:
			!!source_text_or_html && source_text_or_html.trim()
				? htmlDecode(source_text_or_html).trim()
				: '',
		cloudQuestion: !!type && type.toLowerCase() === 'wordcloud',
		liveClassURL:
			segment === 'live-class-link' ? findLiveURL(source_text_or_html.trim()) : '',
		isNotCloze,
		vkDetails: !!karaoke_details ? JSON.parse(karaoke_details) : {},
		domain,
		questionId: question_id,
		question: htmlDecode(question),
		prompt,
		qtype: type,
		qdomain: domain,
		qlevel: level,
	};
};

const getLeftFeedbackProps = ({
	question: {
		source_text_or_html,
		source_youtube_video,
		youtube_start,
		youtube_end,
		type,
		source_image_url,
		domain,
		segment,
		word_bank,
		karaoke_details,
		question_id,
		question,
		prompt,
		level,
		correct_answers,
	},
	answers: { additional_user_answer, user_answer },
}) => {
	let isNotCloze =
		type !== 'CLOZE' &&
		type !== 'Cloze_with_passage' &&
		type !== 'Cloze_with_conversation';

	return {
		videoId: source_youtube_video,
		youtubeStart: youtube_start,
		youtubeEnd: youtube_end,
		queDesc:
			!!source_text_or_html.trim() && isNotCloze
				? htmlDecode(source_text_or_html).trim()
				: '',
		imagesrc: source_image_url,
		wordbank: word_bank,
		clozeQuestion: source_text_or_html.trim(),
		cloudQuestion: !!type && type.toLowerCase() === 'Wordcloud',
		liveClassURL:
			segment === 'live-class-link'
				? findLiveURL(source_text_or_html?.trim())
				: '',
		isNotCloze,
		vkDetails: !!karaoke_details ? JSON.parse(karaoke_details) : {},
		domain,
		questionId: question_id,
		question: htmlDecode(question),
		prompt,
		qtype: type,
		qdomain: domain,
		qlevel: level,
		userAnswer: additional_user_answer,
		correctAnswer:
			Array.isArray(correct_answers) && correct_answers.lenght > 0
				? correct_answers[0].split('#')
				: correct_answers,
		passage: source_text_or_html?.trim().split('[blank]'),
		selectedAnswer: !!additional_user_answer
			? additional_user_answer.split('#')
			: !!user_answer
				? user_answer.split('#')
				: [],
	};
};

const getRightSectionProps = (
	{
		type,
		choices,
		imgchoices,
		audio_choices,
		domain,
		record_length,
		karaoke_details,
		source_text_or_html,
		word_bank,
		question_id,
		question,
		prompt,
		level,
	},
	isFeedback,
) => {
	let instruction = '';
	if (
		!!source_text_or_html !== '' &&
		source_text_or_html?.trim() &&
		type !== 'CLOZE' &&
		type !== 'Cloze_with_passage' &&
		type !== 'Cloze_with_conversation' && domain !== 'L'
	) {
		instruction = readInstruction;
	} else if (domain === 'L') {
		instruction = playAudioInstruction;
	} else {
		instruction = playVideoInstruction;
	}

	let resetCounters = [];

	if (
		!!source_text_or_html &&
		!!source_text_or_html.trim() &&
		type === 'Cloze_with_conversation'
	) {
		var clozeQuestion = htmlDecode(source_text_or_html).split('[blank]');
		resetCounters = Array(clozeQuestion.length - 1).fill(3);
		localStorage.setItem('resetCounters', resetCounters);
	}

	let resetCounter = '';
	if (
		(['SA', 'SASemantic', 'SAkeyword', 'LA', 'Wordcloud'].includes(type) &&
			domain === 'S') ||
		type === 'Cloze_with_passage'
	) {
		resetCounter = 3;
	}
	localStorage.setItem('resetCounter', resetCounter);

	let speechLength = 0;
	if (
		[
			'Cloze_with_passage',
			'SA',
			'SASemantic',
			'SAkeyword',
			'LA',
			'Cloze_with_conversation',
			'VK',
			'Wordcloud',
			'IELTS',
		].includes(type)
	) {
		if (
			['Cloze_with_conversation', 'Cloze_with_passage', 'VK', 'IELTS'].includes(type) ||
			domain === 'S'
		)
			speechLength = record_length;
	}

	return {
		choices,
		imageChoices: imgchoices,
		audioChoices: audio_choices,
		speechLength,
		textLength: ['SA', 'SASemantic', 'SAkeyword', 'LA'].includes(type)
			? type === 'LA'
				? 10
				: 3
			: '',
		vkDetails: !!karaoke_details ? JSON.parse(karaoke_details) : {},
		clozeQuestion: htmlDecode(source_text_or_html),
		cloudQuestion: !!type && type.toLowerCase() === 'wordcloud',
		wordbank: word_bank,
		questionId: question_id,
		question: htmlDecode(question),
		prompt,
		qtype: type,
		qdomain: domain,
		qlevel: level,
		instruction,
		resetCounter,
		resetCounters,
	};
};

const getRightFeedbackProps = ({
	question: {
		type,
		source_text_or_html,
		question_id,
		question,
		correct_answer_1,
		karaoke_details,
		default_feedback,
		domain,
		level,
		choices,
		imgchoices,
		audio_choices,
	},
	answers: {
		score,
		file_url,
		user_answer,
		additional_user_answer,
		karaoke_answer,
		speech_feedback,
		json_response,
		wpm,
		pace_rating,
		phrasing_rating,
	},
	LAfeedback,
}) => {
	// let defaultFeedback = null;
	// let laDefaultFeedback = null;
	// if (type === 'LA' && LAfeedback !== 'none') {
	//     defaultFeedback = LAfeedback
	// } else {
	//     defaultFeedback = default_feedback;
	// }

	let instruction = '';
	if (
		!!source_text_or_html &&
		source_text_or_html.trim() !== '' &&
		type !== 'CLOZE' &&
		type !== 'Cloze_with_passage' &&
		type !== 'Cloze_with_conversation' && domain !== 'L'
	) {
		instruction = readInstruction;
	} else if (domain === 'L') {
		instruction = playAudioInstruction;
	} else {
		instruction = playVideoInstruction;
	}

	let userAnswer = user_answer;
	let correctAnswer = correct_answer_1;
	var tempSourceText = '';

	if (
		type === 'CLOZE' ||
		type === 'Cloze_with_passage' ||
		type === 'Cloze_with_conversation'
	) {
		tempSourceText = htmlDecode(source_text_or_html).split('[blank]');
		var tempUserAnswer = '';
		if (type === 'Cloze_with_passage' || type === 'Cloze_with_conversation') {
			tempUserAnswer = !!additional_user_answer
				? additional_user_answer.split('#')
				: [];
		} else {
			tempUserAnswer = user_answer.split('#');
		}
		var temp_userAnswer = Object.keys(tempUserAnswer).map(function (answer_key) {
			return tempSourceText[answer_key] + ' ' + tempUserAnswer[answer_key];
		});
		userAnswer = temp_userAnswer.join('') + ' ' + tempSourceText.pop();
		if (type === 'Cloze_with_passage' || type === 'Cloze_with_conversation') {
			correctAnswer = correct_answer_1.replace(/<[^>]+>/g, '');
		} else {
			tempSourceText = htmlDecode(source_text_or_html).split('[blank]');

			var temp_correct_answer = correct_answer_1.split('#');
			var temp_correctAnswer = Object.keys(temp_correct_answer).map(function (
				Canswer_key,
			) {
				return tempSourceText[Canswer_key] + ' ' + temp_correct_answer[Canswer_key];
			});
			correctAnswer = temp_correctAnswer.join('') + ' ' + tempSourceText.pop();
		}
	} else if (type === 'MCQ' || type === 'MS') {
		let feedbackChoicesOrder = localStorage.getItem('FeedbackChoicesOrder');
		let feedbackImageChoicesOrder = localStorage.getItem(
			'FeedbackImageChoicesOrder',
		);
		var feedbackChoices =
			!!feedbackChoicesOrder && feedbackChoicesOrder !== 'undefined'
				? JSON.parse(feedbackChoicesOrder)
				: choices;
		var feedbackImageChoices =
			!!feedbackImageChoicesOrder && feedbackImageChoicesOrder !== 'undefined'
				? JSON.parse(feedbackImageChoicesOrder)
				: imgchoices;
		var feedbackAudioChoices = audio_choices;
	}

	return {
		instruction,
		//feedbackQuestionNo: , same as answerCount
		feedbackQuestionId: question_id,
		feedbackQuestion: htmlDecode(question),
		score,
		fileUrl: file_url,
		qdomain: domain,
		type: type,
		qlevel: level,
		json_response: !!json_response ? json_response : {},
		//VK
		karaokeAnswer: JSON.parse(karaoke_answer),
		karaokeDetails: JSON.parse(karaoke_details),
		//audio
		speechFeedback: speech_feedback,
		wpm: wpm,
		paceRating: pace_rating,
		phrasingRating: phrasing_rating,
		//LA
		defaultFeedback: default_feedback,
		laDefaultFeedback: LAfeedback,
		//cloze
		userAnswer,
		correctAnswer,
		textCorrectAnswer: temp_correct_answer,
		selectedAnswer: tempUserAnswer,
		passage: htmlDecode(source_text_or_html).trim().split('[blank]'),
		//mcq
		feedbackChoices,
		feedbackImageChoices,
		feedbackAudioChoices,
	};
};

const findLiveURL = (sourceText) => {
	// eslint-disable-next-line no-useless-escape
	let urlRegex = /<a.+?\s*href\s*=\s*["\']?([^"\'\s>]+)["\']?/gi;
	let url = urlRegex.exec(sourceText);
	return !!url && !!url[1] ? url[1] : '';
};

export const getThankyouModal = (data) => {
	const {
		attempt: {
			attempt_id,
			element_type,
			attempt_name,
			o_level_range,
			cert_url,
			o_level,
			l_score,
			s_score,
			r_score,
			w_score,
			org_id,
			showScore,
		},
		answers: { score },
		cert_id,
		cert_name,
		element_name,
		linkedin_org_id,
		product_promo,
		upnext,
		review_answers,
		baseline_msg
	} = data;

	const backToCourse = `<a href="/mycourse" class="btn btn-primary btn-popup">Back to My Course</a>`;
	const backToMyStep = `<a href="/mystep" class="btn btn-primary btn-popup">Back to My STEP</a>`;

	let thanksval = {};

	thanksval['dailyStepImg'] = '';
	thanksval['modalClass'] = 'thankyou-popup-default';
	thanksval['certImg'] = '';
	thanksval['attemptScore'] = '';
	thanksval['certLink'] = '';
	thanksval['upNextLink'] = '';
	thanksval['myStepLink'] = '';
	thanksval['productPromo'] = '';

	if (!!product_promo) {
		thanksval['productPromo'] = product_promo;
	}

	thanksval['ReviewAttemptId'] = attempt_id;
	thanksval['ElementName'] = element_name;
	thanksval['reviewAnswers'] = review_answers;
	if (element_type === 'W') {
		thanksval['upNext'] = upnext;
		thanksval['myStepLink'] = backToCourse;
	} else if (element_type === 'F') {
		thanksval['upNext'] = upnext;
		thanksval['myStepLink'] = backToCourse;
	} else if (element_type === 'S' && attempt_name === 'free' && !!showScore) {
		thanksval['modalClass'] = 'thankyou-popup-free-red';
		// free attempt
		thanksval['myStepLink'] = backToMyStep;
		thanksval['certImg'] = `<div>
                                <div class="popup-desc-with-certi">You have finished the 'Free Test'</div>
                                <img src='${Config.ASSETSPATH + 'img/certificate.png'
			}' alt="certificate" width="46px" />
                            </div>`;
		thanksval[
			'attemptScore'
		] = `<div class="thankyou-popup-score">${o_level_range}</div>`;
	} else if (element_type === 'S' && !!showScore) {
		// with cert
		thanksval['modalClass'] = 'thankyou-popup-free-red';
		thanksval['certImg'] = `<div>
                                    <div class="popup-desc-with-certi">You have finished the '${element_name}'</div>
                                    <img src='${Config.ASSETSPATH + 'img/certificate.png'
			}' alt="certificate" width="46px" />
                                </div>`;
		if (cert_url !== 'None' && !!cert_url) {
			thanksval['certLink'] = `<div class="thankyou-popup-link-download">
                                        <a href='${cert_url}' target="_blank" rel="noopener noreferrer">Download Certificate</a>
									</div>`;
			thanksval['addToLinkedin'] = `<a
									href="https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${htmlEncode(
				cert_name,
			)}&organizationId=${linkedin_org_id}&issueYear=${moment().format(
				'YYYY',
			)}&issueMonth=${moment().format(
				'MM',
			)}&expirationYear=&expirationMonth=&certUrl=${cert_url}&certId=${cert_id}"
									style={{ cursor: 'pointer' }}
									target="_blank" rel="noopener noreferrer"
								>
									<img
										src="http://download.linkedin.com/desktop/add2profile/buttons/en_US.png"
										alt="LinkedIn Add to Profile button"
									/>
								</a>`;
		}
		thanksval['myStepLink'] = backToMyStep;
		thanksval[
			'attemptScore'
		] = `<div class="thankyou-popup-score">${o_level}</div>`;
	} else if (element_type === 'D') {
		thanksval['modalClass'] = 'thankyou-popup-pink';
		thanksval['dailyStepImg'] = `<img src='${Config.ASSETSPATH + 'img/dailytest_pink.png'
			}' alt="daily step" />`;
		thanksval['upNext'] = upnext;
		thanksval['myStepLink'] = backToMyStep;
	}
	return { ...thanksval, score, l_score, s_score, r_score, w_score, org_id, baseline_msg };
};
